import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppSelectorService } from '../services/app-selector.service';

export const appSelectorGuard: CanActivateFn = () => {
  const appSelectorService = inject(AppSelectorService);
  const router = inject(Router);

  if (appSelectorService.hasSelectedApp()) return true;
  return router.createUrlTree(['/select-app']);
};
